import React from "react";
import { withStyles } from '@material-ui/core/styles';
import { SvgLoader, SvgProxy } from 'react-svgmt';
import testsvg from '../assets/ToothTest.svg';

const styles = theme => ({

  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: 200,
  },
  wrappingA:{
      marginTop:"10vh",
  },
});



class SVGTest extends React.Component {

  state = {
  };


    constructor(props){
        super(props);
        this.props=props;
    }




    componentDidMount = (d)=>{
    };

    


    render(){
        //const { classes } = this.props;
    return (
        <>
                <div>
                    <SvgLoader path={testsvg}>
                        <SvgProxy selector="#tooth_shade" stroke="brown" fill="blue" />
                        <SvgProxy selector="#root_shade" stroke="green" fill="lime" />
                    </SvgLoader>
                </div>
            
        </>
    );
    }

}

export default withStyles(styles)(SVGTest);